import React, { useEffect} from "react";

const Termsofservice = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section class="privacy-policy-con">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h4>Terms and Conditions:</h4>
              <p class="text-size-16">
                Welcome to [Your Online Education Platform]! Before accessing or
                using our website, please read these Terms and Conditions
                carefully. By accessing or using any part of the site, you agree
                to be bound by these Terms and Conditions.
              </p>
              <h5>1. Use of Website:</h5>
              <p class="text-size-16">
                Your use of our website is subject to these Terms and
                Conditions. You must be at least 18 years old to use our
                services.
              </p>
              <h5>2. User Account:</h5>
              <p class="text-size-16">
                You are responsible for maintaining the confidentiality of your
                account and password. You agree to provide accurate and complete
                information when creating an account.
              </p>
              <h5>3. Intellectual Property:</h5>
              <p class="text-size-16">
                All content on this website, including text, graphics, logos,
                and images, is the property of [Your Online Education Platform]
                and protected by copyright laws. You may not reproduce,
                distribute, or transmit any content without prior written
                consent.
              </p>
              <h5>4. Payment and Billing:</h5>
              <p class="text-size-16">
                Payment for our services is required in advance. All fees are
                non-refundable.
              </p>
              <h5>5. Termination:</h5>
              <p class="text-size-16">
                We reserve the right to suspend or terminate your account at any
                time for violation of these Terms and Conditions. Please review
                our full Terms and Conditions for more detailed information.You
                have the right to access, update, or delete your personal
                information at any time. You can opt out of receiving
                promotional emails by following the instructions provided in the
                email. By using our website, you consent to the terms of this
                Privacy Policy. If you have any questions or concerns, please
                contact us.
              </p>
              <p class="text-size-16 mb-0">
                Please review our full Terms and Conditions for more detailed
                information.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Termsofservice;
